import styled from "styled-components";

export const StyledImage = styled.img`
  border-radius: 20px;
  background-image: url("${(props) => props.src}");
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  max-width: ${(props) => props.maxwidth};

  &:hover {
    cursor: pointer;
  }
`;

export const OriginalImageContainer = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  top: 0;
  background-color: rgba(0, 0, 0, 0.87);
  justify-content: center;
  align-items: center;
`;

export const OriginalImageContentVertical = styled.div`
  display: flex;
  flex-direction: column;
  height: 70vh;
`;
export const OriginalImageContentHorizontal = styled.div`
  display: flex;
  flex-direction: column;
  width: 70vw;
`;

export const OriginalImageCaption = styled.div`
  padding-top: 20px;
  padding-left: 2%;
  padding-bottom: 20px;
  width: 98%;
  background-color: white;
`;
